import React, { FC } from 'react'
import { PartnersSearch } from '../../partnerListings'

type Props = {
  showSearch: boolean
  handleShowSearch: any
  searchText: string
  handleSearchInput: any
  searchInputRef: any
  handleCloseSearch: any
  businessPartnersTabUrl: string
  businessPartnersTabText: string
  servicePartnersTabUrl: string
  servicePartnersTabText: string
  publicSectorPartnersTabUrl: string
  publicSectorPartnersTabText: string
  technologyPartnersTabUrl: string
  technologyPartnersTabText: string
}

const Search: FC<Props> = ({
  showSearch,
  handleShowSearch,
  searchText,
  handleSearchInput,
  searchInputRef,
  handleCloseSearch,
  businessPartnersTabUrl,
  businessPartnersTabText,
  servicePartnersTabUrl,
  servicePartnersTabText,
  publicSectorPartnersTabUrl,
  publicSectorPartnersTabText,
  technologyPartnersTabUrl,
  technologyPartnersTabText,
}) => {
  return (
    <PartnersSearch>
      <div className="PartnersLocator__searchContainer">
        <div className="PartnersLocator__search">
          <i
            className={`fa fa-search ${showSearch ? 'active' : ''}`}
            onClick={handleShowSearch}></i>
          <input
            type="text"
            placeholder="Search"
            className={showSearch ? 'expanded' : ''}
            value={searchText}
            onChange={handleSearchInput}
            ref={searchInputRef}
          />
          <i
            className={`fa fa-times close ${showSearch ? 'active' : ''}`}
            onClick={handleCloseSearch}></i>
        </div>
      </div>
      <div className="PartnersLocator__typesContainer">
        <ul className="PartnersLocator__types">
          <li>
            <a href={businessPartnersTabUrl}>{businessPartnersTabText}</a>
          </li>
          <li>
            <a href={servicePartnersTabUrl}>{servicePartnersTabText}</a>
          </li>
          <li>
            <a href={publicSectorPartnersTabUrl}>{publicSectorPartnersTabText}</a>
          </li>
          <li className="selected">
            <a href={technologyPartnersTabUrl}>{technologyPartnersTabText}</a>
          </li>
        </ul>
      </div>
    </PartnersSearch>
  )
}

export default Search
